// Getters
export const GET_SELECTED_CREATIVE_TEMPLATE_ID = 'GET_SELECTED_CREATIVE_TEMPLATE_ID';
export const GET_TEMPLATE_EDITABLE_PROPERTIES = 'GET_TEMPLATE_EDITABLE_PROPERTIES';

// ACTIONS
export const FETCH_TEMPLATES_SEARCH = 'FETCH_TEMPLATES_SEARCH';
export const FETCH_CREATIVE_TYPES = 'FETCH_CREATIVE_TYPES';
export const FETCH_TEMPLATE = 'FETCH_TEMPLATE';
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE';
export const FETCH_TEMPLATE_GROUPS = 'FETCH_TEMPLATE_GROUPS';
export const CREATE_NEW_TEMPLATE_GROUP = 'CREATE_NEW_TEMPLATE_GROUP';
export const FETCH_TEMPLATES_IN_GROUP_ID = 'FETCH_TEMPLATES_IN_GROUP_ID';

// MUTATIONS
export const UPDATE_AVAILABLE_TEMPLATES = 'UPDATE_AVAILABLE_TEMPLATES';
export const SET_CREATIVES_TEMPLATES_EDITABLE_PROPERTIES = 'SET_CREATIVES_TEMPLATES_EDITABLE_PROPERTIES';
export const SET_SELECTED_TEMPLATES = 'SET_SELECTED_TEMPLATES';

// MUTATIONS + ACTIONS
export const CHANGE_SELECTED_CREATIVE_TEMPLATE_GROUP = 'CHANGE_SELECTED_CREATIVE_TEMPLATE_GROUP';
export const SET_SELECTED_GROUP = 'SET_SELECTED_GROUP';
export const UPDATE_SELECTED_TEMPLATES = 'UPDATE_SELECTED_TEMPLATES';
